import { Grid } from "@mui/material";
import { Edit2 } from "iconsax-react";
import { useSearchParams } from "react-router-dom";
import useHeaderInfo from "../../../hooks/useHeaderInfo";

//import styles
import "./details-header.scss";

function DetailsHeader({ type, data }) {
    //general variales
    const [_, setSearchParams] = useSearchParams();
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};

    const { headerTitle, headerDetails } = useHeaderInfo(type, data);

    //handle show edit search form and flight details
    const handleEdittSearch = action => {
        const params = { action };
        setSearchParams(params);
    };

    return (
        <Grid
            className="details-header"
            container
            item
            xs={12}
            columnGap={5}
            justifyContent="center"
            alignItems="center"
            onClick={() => handleEdittSearch("edit")}
        >
            <span className="details-header__title">{headerTitle}</span>
            <span className="details-header__details">({headerDetails})</span>
            {(isItinerary || type == "hotel" || type == "flight" || type === "bus") && (
                <span className="details-header__edit">
                    <Edit2
                        strokeWidth="3px"
                        stroke="15px"
                        size="24"
                        color="var(--light-color)"
                        cursor="pointer"
                        onClick={() => handleEdittSearch("edit")}
                    />
                </span>
            )}
        </Grid>
    );
}

export default DetailsHeader;
